import { css } from "@emotion/react";
import styled from "@emotion/styled";

export const StyledTableWrapper = styled.div`
	position: relative;
	border-bottom: 2px solid #e0e0e0;
`;

export const StyledTable = styled.table`
	width: 100%;
`;

export const TableTr = styled.tr`
	border-bottom: 1px solid #e0e0e0;
`;

export interface TableTdProps {
	bold?: boolean;
	textAlign?: "left" | "center" | "right";
	padding?: Array<string | number>;
}

const getPaddingValue = (value: string | number) => {
	if (typeof value === "number") {
		return `${value}px`;
	}

	return value;
};

const getTableTdPadding = (paddingArray: Array<string | number>): string => {
	if (!paddingArray) {
		return "inherit";
	}

	if (paddingArray.length === 1) {
		return getPaddingValue(paddingArray[0]);
	}

	if (paddingArray.length === 2 || paddingArray.length === 4) {
		return paddingArray.map((v) => getPaddingValue(v)).join(" ");
	}

	return "inherit";
};

export const TableTd = styled.td<TableTdProps>`
	font-size: 14px;
	line-height: 28px;
	${(props) => props.bold && "font-weight: bold"}

	${({ textAlign }) =>
		textAlign &&
		css`
			text-align: ${textAlign};
		`}
	
	${({ padding }) =>
		padding &&
		css`
			padding: ${getTableTdPadding(padding)} !important;
		`}
`;

export const TableHead = styled.thead`
	tr > td {
		padding: 2px 0;
	}
`;

export const TableBody = styled.tbody`
	tr > td {
		padding: 14px 0;
	}
`;

export const TableNoResultText = styled.p`
	padding: 70px 0;
	font-size: 14px;
	font-weight: bold;
	text-align: center;
	border-bottom: 1px solid #e0e0e0;
`;
